module.exports = __webpack_public_path__ + "static/media/service_tile_slowtourism.81110ec7.jpg";